import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ClientEnhancements.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ThemeInit.tsx");
